import styled from 'styled-components'

const LinkIconUi = styled.i`
  &:hover {
    color: #fff;
  }
`
export default LinkIconUi
